import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
export const FreeTipsSection: React.FC = () => {
  const [isRedirecting, setIsRedirecting] = useState(false);
  const handleFreeTipsClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    setIsRedirecting(true);
    setTimeout(() => {
      window.location.href = 'https://body-hack.cz/rady';
    }, 800);
  };
  return <section className="py-16 md:py-24 overflow-hidden relative bg-black" data-id="element-500">
      <div className="container mx-auto px-4 relative z-10" data-id="element-501">
        {/* Ambient background glow */}
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-4xl h-96 bg-green-500/20 blur-[120px] rounded-full pointer-events-none" data-id="element-502" />

        <motion.div initial={{
        opacity: 0,
        y: 40
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="relative max-w-3xl mx-auto" data-id="element-503">
          {/* Glowing Border Wrapper */}
          <div className="absolute -inset-[2px] bg-gradient-to-r from-green-400 via-green-600 to-green-400 rounded-3xl blur-md opacity-70 animate-pulse" data-id="element-504" />
          <div className="absolute -inset-[1px] bg-gradient-to-r from-green-400 via-green-600 to-green-400 rounded-3xl opacity-100" data-id="element-505" />

          {/* Main Card */}
          <div className="relative bg-gradient-to-br from-gray-900 via-black to-gray-900 rounded-3xl overflow-hidden shadow-2xl shadow-green-900/50" data-id="element-506">
            <div className="p-8 md:p-12 lg:p-16 flex flex-col items-center text-center z-10 relative" data-id="element-507">
              {/* Badge */}
              <motion.div initial={{
              opacity: 0,
              scale: 0.8
            }} whileInView={{
              opacity: 1,
              scale: 1
            }} transition={{
              delay: 0.3
            }} className="inline-block mb-6" data-id="element-508">
                <span className="bg-red-600 text-white text-xs md:text-sm font-black uppercase tracking-widest px-4 py-1.5 rounded-full shadow-[0_0_15px_rgba(220,38,38,0.6)] border border-red-400/50" data-id="element-509">
                  100% ZDARMA
                </span>
              </motion.div>

              <motion.h2 initial={{
              opacity: 0,
              y: -20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} transition={{
              delay: 0.4
            }} className="text-5xl md:text-6xl lg:text-7xl font-black text-white italic tracking-tighter leading-[0.9] mb-2 drop-shadow-lg" data-id="element-510">
                Začínáš cvičit?
              </motion.h2>

              <motion.h3 initial={{
              opacity: 0,
              y: -20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} transition={{
              delay: 0.5
            }} className="text-4xl md:text-5xl lg:text-6xl font-black text-white italic tracking-tighter leading-[1] mb-8 drop-shadow-lg" data-id="element-511">
                Pomůžu ti{' '}
                <span className="text-green-500 drop-shadow-[0_0_15px_rgba(34,197,94,0.4)]" data-id="element-512">
                  ZDARMA.
                </span>
              </motion.h3>

              <motion.div initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} transition={{
              delay: 0.6
            }} className="mb-10" data-id="element-513">
                <p className="text-2xl md:text-3xl font-bold text-white italic mb-4" data-id="element-514">
                  Poslechni si{' '}
                  <span className="text-green-500" data-id="element-515">10 tréninkových hacků:</span>
                </p>

                <ul className="space-y-3 text-left inline-block" data-id="element-516">
                  {['jak zrychlit růst svalů', 'jak se vyhnout chybám', 'jak mít rychlejší výsledky'].map((item, idx) => <motion.li key={idx} initial={{
                  opacity: 0,
                  x: -20
                }} whileInView={{
                  opacity: 1,
                  x: 0
                }} transition={{
                  delay: 0.7 + idx * 0.1
                }} className="flex items-center text-xl md:text-2xl font-bold text-white italic" data-id="element-517">
                      <span className="text-green-500 mr-3 text-2xl" data-id="element-518">▸</span>
                      {item}
                    </motion.li>)}
                </ul>
              </motion.div>

              <motion.div initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} transition={{
              delay: 1
            }} data-id="element-519">
                <motion.button onClick={handleFreeTipsClick} disabled={isRedirecting} animate={{
                scale: [1, 1.03, 1],
                boxShadow: ['0 0 20px rgba(34, 197, 94, 0.4)', '0 0 40px rgba(34, 197, 94, 0.8)', '0 0 20px rgba(34, 197, 94, 0.4)']
              }} transition={{
                duration: 2,
                repeat: Infinity,
                ease: 'easeInOut'
              }} whileHover={{
                scale: 1.05
              }} whileTap={{
                scale: 0.95
              }} className="w-full md:w-auto bg-gradient-to-r from-green-500 to-green-400 text-black font-black text-xl md:text-2xl py-5 px-10 rounded-2xl shadow-[0_0_30px_rgba(34,197,94,0.6)] border-2 border-green-300 disabled:opacity-80 disabled:cursor-not-allowed uppercase tracking-wide" data-id="element-520">
                  {isRedirecting ? 'PŘESMĚROVÁVÁM...' : 'CHCI RADY ZDARMA!'}
                </motion.button>
              </motion.div>
            </div>
          </div>
        </motion.div>
      </div>

      {/* Redirecting Overlay */}
      <AnimatePresence data-id="element-521">
        {isRedirecting && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} className="fixed inset-0 bg-black/95 backdrop-blur-md z-[100] flex items-center justify-center" data-id="element-522">
            <motion.div initial={{
          scale: 0.9,
          opacity: 0
        }} animate={{
          scale: 1,
          opacity: 1
        }} transition={{
          delay: 0.1
        }} className="text-center" data-id="element-523">
              <div className="mb-6" data-id="element-524">
                <motion.div animate={{
              rotate: 360
            }} transition={{
              duration: 1,
              repeat: Infinity,
              ease: 'linear'
            }} className="w-20 h-20 border-4 border-green-500 border-t-transparent rounded-full mx-auto shadow-[0_0_30px_rgba(34,197,94,0.5)]" data-id="element-525" />
              </div>
              <h3 className="text-3xl font-black text-white mb-3 italic tracking-tight" data-id="element-526">
                Připravuji tvé{' '}
                <span className="text-green-500" data-id="element-527">rady zdarma...</span>
              </h3>
              <p className="text-gray-400 text-lg" data-id="element-528">
                Moment prosím, hned tě přesměrujeme 🚀
              </p>
            </motion.div>
          </motion.div>}
      </AnimatePresence>
    </section>;
};